export const status_aktif = [
    { key: '1', value: 'Aktif' },
    { key: '0', value: 'Non Aktif' },
]
export const ganti_soal = [
    { key: '1', value: 'Ya' },
    { key: '0', value: 'Tidak' },
]
export const status_import = [
    { key: '1', value: 'Import data siswa' },
    { key: '0', value: 'Import RFID siswa' },
]

export const status_import_guru = [
    { key: '1', value: 'Import data guru' },
    { key: '0', value: 'Import RFID guru' },
]
export const sekolahApiVersion = "/v3prod";

export const ckConfig = {
    extraPlugins: 'image2,uploadimage',

    // Configure your file manager integration. This example uses CKFinder 3 for PHP.
    // filebrowserBrowseUrl: '/apps/ckfinder/3.4.5/ckfinder.html',
    filebrowserImageBrowseUrl: '/apps/ckfinder/3.4.5/ckfinder.html?type=Images',
    filebrowserUploadUrl: '/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files',
    filebrowserImageUploadUrl: '/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Images',

    // Upload dropped or pasted images to the CKFinder connector (note that the response type is set to JSON).
    uploadUrl: '/apps/ckfinder/3.4.5/core/connector/php/connector.php?command=QuickUpload&type=Files&responseType=json',

    // Reduce the list of block elements listed in the Format drop-down to the most commonly used.
    format_tags: 'p;h1;h2;h3;pre',
    // Simplify the Image and Link dialog windows. The "Advanced" tab is not needed in most cases.
    removeDialogTabs: 'image:advanced;link:advanced',

    height: 450
}

export const dataLevel = [
    { key: "administrator", value: "Administrator" },
    { key: "admin_konten", value: "Admin Konten" },
    { key: "akademik", value: "Akademik" },
    { key: "keuangan", value: "Keuangan" },
    { key: "guru", value: "Guru" },
    { key: "siswa", value: "Siswa" },
    { key: "wali", value: "Wali" },
]


// WEBPACK FOOTER //
// ./src/constants/general.js